module.exports = __webpack_public_path__ + "static/media/1.question.74580e54.mp4";